// @ts-nocheck
export enum DialogsName {
  AccountForm = 'account-form',
  CurrencyForm = 'currency-form',
  InviteForm = 'invite-user',
  UserForm = 'user-form',
  ExchangeRateForm = 'exchangeRate-form',
  ItemCategoryForm = 'item-category-form',
  InventoryAdjustmentForm = 'inventory-adjustment',
  PaymentViaVoucherForm = 'payment-via-voucher',
  KeyboardShortcutForm = 'keyboard-shortcuts',
  ContactDuplicateForm = 'contact-duplicate',
  QuickPaymentReceiveForm = 'quick-payment-receive',
  QuickPaymentMadeForm = 'quick-payment-made',
  QuickJournalBalanceForm = 'quick-journal-balance',
  ManualJournalPdfPreview = 'manual-journal-pdf-preview',
  AllocateLandedCostForm = 'allocate-landed-cost',
  InvoicePdfForm = 'invoice-pdf-preview',
  BillPdfForm = 'bill-pdf-preview',
  BillPaymentPdfForm = 'bill-payment-pdf-preview',
  BillPayment2307PdfForm = 'bill-payment-2307-pdf-preview',
  EstimatePdfForm = 'estimate-pdf-preview',
  ReceiptPdfForm = 'receipt-pdf-preview',
  CreditNotePdfForm = 'credit-note-pdf-preview',
  PaymentPdfForm = 'payment-pdf-preview',
  ExpensePdfForm = 'expense-pdf-preview',
  MoneyInForm = 'money-in',
  MoneyOutForm = 'money-out',
  NotifyInvoiceViaForm = 'notify-invoice-via-sms',
  NotifyReceiptViaForm = 'notify-receipt-via-sms',
  NotifyEstimateViaForm = 'notify-estimate-via-sms',
  NotifyPaymentViaForm = 'notify-payment-via-sms',
  BadDebtForm = 'write-off-bad-debt',
  SMSMessageForm = 'sms-message-form',
  RefundCreditNote = 'refund-credit-note',
  RefundVendorCredit = 'refund-vendor-credit',
  ReconcileCreditNote = 'reconcile-credit-note',
  ReconcileVendorCredit = 'reconcile-vendor-credit',
  TransactionsLocking = 'locking-transactions',
  TransactionsUnlocking = 'unlocking-transactions',
  PartialTransactionsUnlocking = 'unlocking-partial-transactions',
  WarehouseForm = 'warehouse-form',
  BranchForm = 'branch-form',
  BranchActivateForm = 'branch-activate',
  WarehouseActivateForm = 'warehouse-activate',
  CustomerOpeningBalanceForm = 'customer-opening-balance',
  VendorOpeningBalanceForm = 'vendor-opening-balance',
  ProjectForm = 'project-form',
  ProjectTaskForm = 'project-task-form',
  ProjectTimeEntryForm = 'project-time-entry-form',
  ProjectExpenseForm = 'project-expense-form',
  EstimateExpenseForm = 'estimate-expense-form',
  ProjectInvoicingForm = 'project-invoicing-form',
  ProjectBillableEntriesForm = 'project-billable-entries',
  InvoiceNumberSettings = 'InvoiceNumberSettings',
  TaxRateForm = 'tax-rate-form',
  WithholdingTaxRateForm = 'withholding-tax-rate-form',
  InvoiceExchangeRateChangeNotice = 'InvoiceExchangeRateChangeNotice',
  InvoiceMail = 'invoice-mail',
  BillMail = 'bill-mail',
  BillPaymentMail = 'bill-payment-mail',
  EstimateMail = 'estimate-mail',
  ReceiptMail = 'receipt-mail',
  PaymentMail = 'payment-mail',
  ConnectBankCreditCard = 'connect-bank-credit-card',
  InvoiceFormMailDeliver = 'InvoiceFormMailDeliver',
  EstimateFormMailDeliver = 'EstimateFormMailDeliver',
  ReceiptFormMailDeliver = 'ReceiptFormMailDeliver',
  BalanceSheetPdfPreview = 'BalanceSheetPdfPreview',
  TrialBalanceSheetPdfPreview = 'TrialBalanceSheetPdfPreview',
  CashflowSheetPdfPreview = 'CashflowSheetPdfPreview',
  ProfitLossSheetPdfPreview = 'ProfitLossSheetPdfPreview',
  InventoryValuationPdfPreview = 'InventoryValuationPdfPreview',
  APAgingSummaryPdfPreview = 'APAgingSummaryPdfPreview',
  ARAgingSummaryPdfPreview = 'ARAgingSummaryPdfPreview',
  JournalPdfPreview = 'JournalPdfPreview',
  SalesByItemsPdfPreview = 'SalesByItemsPdfPreview',
  PurchasesByItemsPdfPreview = 'PurchasesByItemsPdfPreview',
  SOAPdfPreview = 'SOAPdfPreview',
  VendorBalancePdfPreview = 'VendorBalancePdfPreview',
  InventoryItemDetailsPdfPreview = 'InventoryItemDetailsPdfPreview',
  CustomerBalanceSummaryPdfPreview = 'CustomerBalanceSummaryPdfPreview',
  CustomerTransactionsPdfPreview = 'CustomerTransactionsPdfPreview',
  VendorTransactionsPdfPreview = 'VendorTransactionsPdfPreview',
  GeneralLedgerPdfPreview = 'GeneralLedgerPdfPreview',
  SalesTaxLiabilitySummaryPdfPreview = 'SalesTaxLiabilitySummaryPdfPreview',
  BIR2550PdfPreview = 'BIR2550PdfPreview',
  Export = 'Export',
  BankRuleForm = 'BankRuleForm',
  DisconnectBankAccountConfirmation = 'DisconnectBankAccountConfirmation',
}
